module.exports = __webpack_public_path__ + "static/img/18-1.d4f8237.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/18-1.jpg
// module id = fOvN
// module chunks = 0